import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `خانهٔ چت ناشناس ${ctx.brand}`,
    languageButtonLabel: `زبان`,
    languageModalTitle: `زبان را انتخاب کنید`,
    languageModalCloseLabel: `بستن منوی زبان`,
  },
  languageOptions: {
    'en-US': {
      label: `انگلیسی (ایالات متحده)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `انگلیسی (کنیا)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `انگلیسی (نیجریه)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `انگلیسی (سنگاپور)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `پرتغالی (پرتغال)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `پرتغالی (برزیل)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `آلمانی (آلمان)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `آلمانی (اتریش)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `آلمانی (سوئیس)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `اسپانیایی (اسپانیا)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `فرانسوی (فرانسه)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `ایتالیایی (ایتالیا)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `هلندی (هلند)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `لهستانی (لهستان)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `سوئدی (سوئد)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `دانمارکی (دانمارک)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `فنلاندی (فنلاند)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `نروژی (نروژ)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `ایسلندی (ایسلند)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `ژاپنی (ژاپن)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `کره‌ای (کرهٔ جنوبی)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `چینی (چین)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `کانتونی (هنگ‌کنگ، منطقهٔ ویژهٔ اداری چین)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `ویتنامی (ویتنام)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `تایلندی (تایلند)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `اندونزیایی (اندونزی)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `سواحیلی (کنیا)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `هندی (هند)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `بنگالی (بنگلادش)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `مراتی (هند)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `تلوگویی (هند)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `فارسی (ایران)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو (پاکستان)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی (پاکستان)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `نیم‌زبان نیجریه‌ای (نیجریه)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `روسی (روسیه)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `عربی (عربستان سعودی)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `عربی (امارات متحدهٔ عربی)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `عربی (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `عربی مراکشی (مراکش)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `ترکی استانبولی (ترکیه)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `انتخاب زبان`,
    closeLabel: `بستن منوی زبان`,
  },
  languageHint: (ctx) => `بدون ساخت حساب در بیش از ${ctx.localesCount} زبان جابه‌جا شو.`,
  readPagePrompt: ({languageLabel}) => `این صفحه را به زبان ${languageLabel} بخوانید.`,
};
